"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputFormats = void 0;
var datapool_1 = require("../types/datapool");
exports.inputFormats = [
    {
        id: datapool_1.TRAINING,
        name: 'Training Table',
        description: {
            id: 'no-id',
            defaultMessage: 'The input for the Augurs consists of training tables that contain a label column',
        },
    },
    {
        id: datapool_1.POPULATION_EVENTS,
        name: 'Population / Events',
        description: {
            id: 'no-id',
            defaultMessage: 'The training tables are derived dynamically based on a population and an event table',
        },
    },
    // { id: CYCLIC_TIMESERIES, name: 'Cyclic Timeseries' },
];
//# sourceMappingURL=datapool.js.map